const hotelLabelsById = {
    "1": "Hilton Garden Inn Santa Ana",
    "2": "Wyndham Garden Escazu",
    "3": "Holiday Inn",
    "4": "Otro",
};

/**
 * Normaliza el campo de hoteles asignados del articulo a un arreglo de ids string.
 *
 * @param {string[]|string|null|undefined} hotelesSeleccionados
 * @returns {string[]}
 */
export const normalizeHotelIds = (hotelesSeleccionados) => {
    if (Array.isArray(hotelesSeleccionados)) {
        return hotelesSeleccionados.map((hotel) => `${hotel}`.trim()).filter(Boolean);
    }

    if (typeof hotelesSeleccionados === "string") {
        try {
            const parsedHotels = JSON.parse(hotelesSeleccionados);

            if (Array.isArray(parsedHotels)) {
                return parsedHotels.map((hotel) => `${hotel}`.trim()).filter(Boolean);
            }
        } catch (error) {
            return hotelesSeleccionados
                .split(",")
                .map((hotel) => hotel.trim())
                .filter(Boolean);
        }
    }

    return [];
};

/**
 * Determina si un articulo pertenece al hotel seleccionado.
 * Usa `hotelesSeleccionados` como fuente principal y cae a `hotel_articulo` para datos legacy.
 *
 * @param {object} articulo
 * @param {string|number|null|undefined} hotelSeleccionado
 * @returns {boolean}
 */
export const articleMatchesHotel = (articulo, hotelSeleccionado) => {
    const normalizedHotel = `${hotelSeleccionado || ""}`.trim();

    if (!normalizedHotel || normalizedHotel === "200") {
        return true;
    }

    const hotelIds = normalizeHotelIds(articulo.hotelesSeleccionados);

    if (hotelIds.length > 0) {
        return hotelIds.includes(normalizedHotel);
    }

    return `${articulo.hotel_articulo || ""}`.trim() === normalizedHotel;
};

/**
 * Construye opciones de articulos segun hotel y orden alfabetico.
 *
 * @param {object[]} articulos
 * @param {string|number|null|undefined} hotelSeleccionado
 * @returns {{value:number,label:string}[]}
 */
export const buildArticuloOptionsByHotel = (articulos, hotelSeleccionado) =>
    articulos
        .filter((articulo) => articleMatchesHotel(articulo, hotelSeleccionado))
        .sort((a, b) => a.nombre_articulo.localeCompare(b.nombre_articulo, "es", { sensitivity: "base" }))
        .map((articulo) => {
            const hotelIds = normalizeHotelIds(articulo.hotelesSeleccionados);
            const hotelNames = hotelIds.map((hotelId) => hotelLabelsById[hotelId] || hotelId);

            return {
                value: articulo.id_articulo,
                label: articulo.nombre_articulo,
                hotelNames,
                hotelNamesText: hotelNames.length > 0 ? hotelNames.join(" • ") : "Sin hotel asignado",
                hasAssignedHotels: hotelNames.length > 0,
            };
        });
